import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

// HOC button component for auth pages
export default function AuthButton(props) {
    const { children, container, ...restProps } = props;

    const button = (
        <Button color="inherit" variant="outlined" {...restProps}>
            {children}
        </Button>
    );

    if (container) {
        return cloneElement(container, null, button);
    }

    return button;
}

AuthButton.propTypes = {
    container: PropTypes.node,
};

AuthButton.defaultProps = {
    container: null,
};
